// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconFeePath = 'M18.188 0H1.855v19.9l3.389-2.3 2.388 1.62 2.95-2-1.122-1.655-1.828 1.24-2.388-1.62-1.39.941V2h12.334v8.637h2V0ZM14.65 6.02H5.392v-2h9.258v2Zm-2.628 3.955H5.409v-2h6.613v2Zm1.489 7.063v-.651c.662.24 1.439.368 2.245.368.805 0 1.582-.128 2.244-.368v.652s.002.036-.055.111a1.248 1.248 0 0 1-.386.31c-.411.232-1.047.407-1.804.407-.756 0-1.392-.175-1.803-.407a1.248 1.248 0 0 1-.386-.31c-.057-.075-.055-.111-.055-.111Zm-2-2.967c.032-.996.824-1.64 1.503-1.98.753-.377 1.724-.58 2.742-.58 1.017 0 1.988.203 2.74.58.68.34 1.472.984 1.503 1.98l.001.059v2.908c0 1.026-.727 1.752-1.46 2.165-.762.43-1.749.664-2.784.664-1.036 0-2.023-.234-2.786-.664-.732-.413-1.459-1.139-1.459-2.165V14.072Zm2.03.062c.046.053.148.143.367.252.421.21 1.073.37 1.848.37.774 0 1.425-.16 1.846-.37.22-.11.322-.2.368-.252-.046-.053-.148-.144-.367-.253-.422-.21-1.073-.37-1.848-.37-.774 0-1.426.16-1.847.37-.219.11-.32.2-.367.252Z';
var IconFee = baseIcon('IconFee', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconFeePath
});
export default IconFee;
//# sourceMappingURL=index.js.map